<div class="ibox">
    <div class="ibox-content" *ngIf="event">

        <div class="eventDetails">
            <div class="row title">
                <div class="col-md-12">
                    <h1 [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.title'}]"></h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-1">
                    <button class="btn btn-primary btn-outline btn-md pull-left"
                            [i18n]="[{target: 'attribute:title', key: 'webhooks-events.details.back'}]"
                            type="button"
                            (click)="onBackSelected()">
                        <span class="fa fa-arrow-left"></span>
                    </button>
                </div>
                <div class="col-md-3 eventDetails-value">
                    <label [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event.type'}]"></label>
                    <app-webhook-event-type [type]="event.eventType"></app-webhook-event-type>
                </div>
                <div class="col-md-3 eventDetails-value">
                    <label [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event.date'}]"></label>
                    <span>{{ event.triggeredDate | fullDate }}</span>
                </div>
                <div class="col-md-2 eventDetails-value">
                    <label [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event.status'}]"></label>
                    <app-webhook-event-status [status]="event.status"
                                              [nextTryDate]="event.nextTryDate">
                    </app-webhook-event-status>
                    <span *ngIf="event.nextTryDate" [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.next-try-date',
                          params: {tryDate: event.nextTryDate | fullDate}}]">
                    </span>

                </div>
                <div class="col-md-2 eventDetails-value">
                    <label [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event.delivery'}]"></label>
                    <span><a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(event.externalReference1?.join(','))" target="_blank">
                        {{ event.externalReference1 | joinArray }}
                    </a></span>
                </div>
                <div class="col-md-1 eventDetails-value">
                    <button class="btn btn-primary" (click)="refreshDetails()">
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>
            </div>
        </div>

        <hr>

        <div class="row eventData">
            <div class="col-md-12 title">
                <h1 [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.title-data'}]"></h1>
            </div>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-10">
                        <pre class="eventData-code" #jsonCodePre>{{event.message | json}}</pre>
                    </div>
                    <div class="col-md-2 eventData-actions">
                        <button class="btn btn-primary btn-sm pull-left"
                                [i18n]="[{target: 'attribute:title', key: 'webhooks-events.details.copy-json.tooltip'}]"
                                (click)="copyJson(event.message)"
                                type="button">
                            <span class="fa fa-copy"></span>
                        </button>
                        <button class="btn btn-primary btn-outline btn-sm pull-left"
                                [i18n]="[{target: 'attribute:title', key: 'webhooks-events.details.open-json.tooltip'}]"
                                type="button"
                                (click)="openJsonInEditor(event.message)">
                            <span class="fa fa-external-link-alt"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row eventTrie inner-space-top-30">
            <div class="col-md-12 title">
                <h1 [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.title-tries'}]"></h1>
                <div class="alert alert-info m-t-sm m-b-sm">
                    <i class="fa fa-info-circle"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.max-tries-info', params: {maxTries: maxAutomaticTries}}]"></span>
                    <ng-container *ngIf="event.nextTryDate">
                        <br>
                        <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.next-try-date', params: {tryDate: event.nextTryDate | fullDate}}]"></span>
                    </ng-container>
                </div>
            </div>
            <div class="col-md-12">
                <div class="row eventTrie-headTable">
                    <div class="col-md-10" [i18n]="[{target: 'attribute:title', key: event.status !== EventStatus.FAILED ? 'webhooks-events.details.retry-send.title' : ''}]">
                        <button class="btn btn-primary btn-md"
                                (click)="retrySendingEvent(event.id)"
                                [disabled]="event.status !== EventStatus.FAILED || actionInProgress"
                                [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.retry-send.label'}]">
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-12 space-top-15">
                <div class="table-responsive">
                    <table class="table table-striped text-left">
                        <thead>
                            <tr>
                                <th [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event-history.date'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event-history.status'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event-history.comment'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event-history.http-verb'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event-history.url'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event-history.trigger-source.label'}]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eventHistory of event.eventHistories">
                                <td>{{eventHistory.createdAt | fullDate}}</td>
                                <td>
                                    <app-webhook-event-history-status [status]="eventHistory.status">
                                    </app-webhook-event-history-status>
                                </td>
                                <td>
                                    <ng-container *ngIf="eventHistory.comment">
                                        <button class="btn btn-primary btn-sm m-r-sm" (click)="openJsonInEditor(eventHistory.comment, false)">
                                            <i class="fa fa-external-link-alt"></i>
                                        </button>
                                        <button class="btn btn-default btn-sm" (click)="copyJson(eventHistory.comment, false)" [i18n]="[{target: 'attribute:title', key: 'copy.tooltip'}]">
                                            <i class="fa fa-copy"></i>
                                        </button>
                                    </ng-container>
                                    <span *ngIf="!eventHistory.comment">-</span>
                                </td>
                                <td>{{eventHistory.httpVerbCallback}}</td>
                                <td>{{eventHistory.urlCallback}}</td>
                                <td>
                                    <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.details.event-history.trigger-source.' + eventHistory.triggerSource}]"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

